import { useLazyQuery, useMutation } from "@apollo/client/react";
import { Box, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorDialog from '../../../components/ErrorDialog';
import { getDateNow } from '../../../utils/convert';
import TabCategorizacion from '../components/TabCategorizacion';
import TabContraindicaciones from '../components/TabContraindicaciones';
import TabDatosContables from '../components/TabDatosContables';
import TabDatosGenerales from '../components/TabDatosGenerales';
import TabProgramas from '../components/TabProgramas';
import { CustomButton } from '../../../components/customButton/CustomButton';
import PropTypes from 'prop-types';

import { POST_SAVE_INSUMO } from '../../../data/graphQL/mutations/Insumos/mutations';
import {
  GET_ALERGIAS,
  GET_ALERGIAS_BY_INSUMO,
  GET_COMPATIBILIDADES_BY_INSUMO,
  GET_COSTOS_BY_INSUMO,
  GET_FABRICANTES,
  GET_FRANJA_ETARIA,
  GET_INSUMO_CAJAS_BY_INSUMO,
  GET_PRODUCT,
  GET_TIPO_MODULO_BY_INSUMO,
  GET_TIPOS_ACCESOS_BY_INSUMO,
  GET_TIPO_ACCESO,
  GET_TIPO_INSUMOS,
  GET_TM_BY_INSUMO,
  GET_UNIDADES } from
'../../../data/graphQL/queries/Insumos/queries';

import { styled } from '@mui/material/styles';

const AntTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#52BA50'
  },
  '& .MuiTabs-scrollButtons.Mui-disabled': {
    opacity: '0.3'
  }
});

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: {
    minWidth: 0
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  color: 'black',
  '&:hover': {
    color: '#52BA50',
    opacity: 1
  },
  '&.Mui-selected': {
    color: '#52BA50',
    fontWeight: 600
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#d1eaff'
  }
}));

export default function Insumo({ setChildrenAction, setHeaderContent, setFooterContent }) {

  const { state } = useLocation();
  const navigate = useNavigate();

  const { insumo, edit, id, listaInsumos, showGrabar } = state;

  const [value, setValue] = useState(0);
  const [grabarLoading, setGrabarLoading] = useState(false);

  const [unidades, setUnidades] = useState([]);
  const [fabricantes, setFabricantes] = useState([]);
  const [tipoInsumos, setTipoInsumos] = useState([]);
  const [franjaEtarias, setFranjaEtarias] = useState([]);

  const [elecciones, setElecciones] = useState([]);
  const [tiposAcceso, setTiposAcceso] = useState([]);
  const [alergias, setAlergias] = useState([]);

  const [comboTiposAcceso, setComboTiposAcceso] = useState([]);
  const [listaDatosContables, setListaDatosContables] = useState([]);

  const [listaProductosCaja, setListaProductosCaja] = useState([]);
  const [listaTM, setListaTM] = useState([]);
  const [listaAccesos, setListaAccesos] = useState([]);

  // Contraindicaciones
  const [listaAlergias, setListaAlergias] = useState([]);
  const [listaCompatibilidad, setListaCompatibilidad] = useState([]);

  const [listaProgramas, setListaProgramas] = useState([]);

  const [insumoData, setInsumoData] = useState({
    datosGenerales: {
      Id: 0,
      IdInsumo: '',
      EsSAP: 0,
      IdUnidad: 0,
      Descripcion: '',
      IdFabricante: 0,
      IdTipoInsumo: 0,
      DescripcionGenerica: '',
      PresentacionGenerica: '',
      Activo: true,
      PresentacionComercial: '',
      IdFranjaEtarea: 0,
      CantidadPack: '',
      Peso: '',
      CantidadDias: 0,
      IdEleccion: 0,
      Validado: false,
      MotivoValidacion: '',
      UnidadVenta: 0,
      Fraccionable: false,
      Calorias: '',
      Proteinas: ''
    },
    datosCategorizacion: {
      IdInsumo: id,
      IdEleccion: 0
    }
  });

  useEffect(() => {
    setChildrenAction(() =>
    showGrabar &&
    <CustomButton
      onClick={handleClickGrabar}
      isLoading={grabarLoading}>
      
                    Guardar
                </CustomButton>
    );

    setFooterContent(() =>
    <>
            </>
    );

    setHeaderContent(() =>
    <Box sx={{ width: '100%' }}>
                <Box>
                    <AntTabs
          allowScrollButtonsMobile
          aria-label="basic tabs example"
          onChange={handleChange}
          scrollButtons="auto"
          value={value}
          variant="scrollable">
          
                        <AntTab label="Datos Generales" {...a11yProps(0)} />
                        <AntTab label="Datos Contables" {...a11yProps(1)} />
                        <AntTab label="Contraindicaciones/ Compatibilidades" {...a11yProps(2)} />
                        <AntTab label="Programas" {...a11yProps(3)} />
                        {(insumoData.datosGenerales.IdTipoInsumo == 1 || insumoData.datosGenerales.IdTipoInsumo == 2) &&
          <AntTab label="Categorizacion" {...a11yProps(4)} />
          }
                    </AntTabs>
                </Box>
            </Box>

    );

  }, [
  setChildrenAction,
  insumoData,
  value,
  listaAlergias,
  listaCompatibilidad,
  listaTM,
  listaAccesos,
  listaProgramas,
  listaDatosContables,
  listaProductosCaja,
  grabarLoading]
  );

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    // solapa generales
    getUnidades();
    getFabricantes();
    getTipoInsumos();
    getFranjaEtarias();

    // solapa categorizacion
    // getCategorias()
    //getSubCategorias();
    // getPresentaciones();
    getTiposAcceso();

    // solapa Contraindicaciones
    getAlergias();

    if (edit) {
      getInsumo({ variables: { id: id } });
      //datos contables
      getCostos({ variables: { idInsumo: id } });
      //contraindicaciones
      getAlergiasByInsumo({ variables: { idInsumo: id } });
      getCompatibilidadesByInsumo({ variables: { idInsumo: id } });
      //categorizacion
      getTipoAccesosByInsumo({ variables: { idInsumo: id } });
      getTMByInsumo({ variables: { idInsumo: id } });
      getInsumoCajasByInsumo({ variables: { idInsumo: id } });
      //programas
      getProgramasByInsumo({ variables: { idInsumo: id } });
    }

  }, []);

  const [getInsumo, { error: errorInsumo, data: dataInsumo }] = useLazyQuery(GET_PRODUCT, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataInsumo) return;
    if (dataInsumo.producto.success) {
      const data = dataInsumo.producto.valorEsperado;
      setInsumoData((prevState) => {
        return {
          ...prevState,
          datosGenerales: {
            Id: data.idInsumoN,
            IdInsumo: data.idInsumo,
            EsSAP: data.esSap,
            IdUnidad: data.idUnidad - 1,
            Descripcion: data.descripcion,
            IdFabricante: data.idFabricante,
            IdTipoInsumo: data.idTipoInsumo,
            DescripcionGenerica: data.descripcionGenerica,
            Activo: data.activo,
            PresentacionGenerica: data.presentacionGenerica,
            PresentacionComercial: data.presentacion,
            IdFranjaEtarea: data.idFranjaEtarea - 1,
            CantidadPack: data.cantXPack,
            Peso: data.pesoUnitario,
            CantidadDias: data.cantXDia,
            IdEleccion: data.idEleccion,
            Validado: data.validado,
            MotivoValidacion: data.motivoValidacion,
            UnidadVenta: data.unidadVenta,
            Fraccionable: data.fraccionable,
            Calorias: data.calorias,
            Proteinas: data.proteinas
          },
          datosCategorizacion: {
            IdInsumo: data.idInsumoN,
            IdEleccion: data.eleccion
          }
        };
      });
    };
  }, [dataInsumo]);  

  useEffect(() => {
    if (!errorInsumo) return;
    setMensajeError("ERRORDB");
  }, [errorInsumo]);  

  // Consultas de combos
  const [getUnidades, { error: errorUnidades, data: dataUnidades }] = useLazyQuery(GET_UNIDADES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataUnidades) return;
    if (dataUnidades.unidades.success) {
      setUnidades(dataUnidades.unidades.valorEsperado);
    };
  }, [dataUnidades]);  

  useEffect(() => {
    if (!errorUnidades) return;
    setMensajeError("ERRORDB");
  }, [errorUnidades]);  

  const [getFabricantes, { error: errorFabricantes, data: dataFabricantes }] = useLazyQuery(GET_FABRICANTES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFabricantes) return;
    if (dataFabricantes.laboratoriosFabricantes.success) {
      setFabricantes(dataFabricantes.laboratoriosFabricantes.valorEsperado);
    };
  }, [dataFabricantes]);

  useEffect(() => {
    if (!errorFabricantes) return;
    setMensajeError("ERRORDB");
  }, [errorFabricantes]);

  const [getTipoInsumos, { error: errorTipoInsumos, data: dataTipoInsumos }] = useLazyQuery(GET_TIPO_INSUMOS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTipoInsumos) return;
    if (dataTipoInsumos.tiposInsumos.success) {
      setTipoInsumos(dataTipoInsumos.tiposInsumos.valorEsperado);
    };
  }, [dataTipoInsumos]);

  useEffect(() => {
    if (!errorTipoInsumos) return;
    setMensajeError("ERRORDB");
  }, [errorTipoInsumos]);  

  const [getFranjaEtarias, { error: errorFranjaEtarias, data: dataFranjaEtarias }] = useLazyQuery(GET_FRANJA_ETARIA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFranjaEtarias) return;
    if (dataFranjaEtarias.franjaEtaria.success) {
      setFranjaEtarias(dataFranjaEtarias.franjaEtaria.valorEsperado);
    };
  }, [dataFranjaEtarias]);

  useEffect(() => {
    if (!errorFranjaEtarias) return;
    setMensajeError("ERRORDB");
  }, [errorFranjaEtarias]);    

  const [getTiposAcceso, { error: errorTipoAcceso, data: dataTipoAcceso }] = useLazyQuery(GET_TIPO_ACCESO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTipoAcceso) return;
    if (dataTipoAcceso.tipoAcceso.success) {
      setTiposAcceso(dataTipoAcceso.tipoAcceso.valorEsperado);
    };
  }, [dataTipoAcceso]);

  useEffect(() => {
    if (!errorTipoAcceso) return;
    setMensajeError("ERRORDB");
  }, [errorTipoAcceso]);    

  const [getAlergias, { error: errorAlergias, data: dataAlergias }] = useLazyQuery(GET_ALERGIAS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataAlergias) return;
    if (dataAlergias.alergias.success) {
      setAlergias(dataAlergias.alergias.valorEsperado);
    };
  }, [dataAlergias]);

  useEffect(() => {
    if (!errorAlergias) return;
    setMensajeError("ERRORDB");
  }, [errorAlergias]);  

  const [getCostos, { error: errorCosto, data: dataCosto }] = useLazyQuery(GET_COSTOS_BY_INSUMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCosto) return;
    if (dataCosto.costoInsumo.success) {
      setListaDatosContables(dataCosto.costoInsumo.valorEsperado);
    };
  }, [dataCosto]);

  useEffect(() => {
    if (!errorCosto) return;
    setMensajeError("ERRORDB");
  }, [errorCosto]);  

  const [getAlergiasByInsumo, { error: errorAlergiasByInsumo, data: dataAlergiasByInsumo }] = useLazyQuery(GET_ALERGIAS_BY_INSUMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataAlergiasByInsumo) return;
    if (dataAlergiasByInsumo.productoAlergias.success) {
      setListaAlergias(dataAlergiasByInsumo.productoAlergias.valorEsperado);
    };
  }, [dataAlergiasByInsumo]);

  useEffect(() => {
    if (!errorAlergiasByInsumo) return;
    setMensajeError("ERRORDB");
  }, [errorAlergiasByInsumo]);    

  const [getTipoAccesosByInsumo, { error: errorTipoAccesoByInsumo, data: dataTipoAccesoByInsumo }] = useLazyQuery(GET_TIPOS_ACCESOS_BY_INSUMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTipoAccesoByInsumo) return;
    if (dataTipoAccesoByInsumo.productoTipoAcceso.success) {
      setListaAccesos(dataTipoAccesoByInsumo.productoTipoAcceso.valorEsperado);
    };
  }, [dataTipoAccesoByInsumo]);

  useEffect(() => {
    if (!errorTipoAccesoByInsumo) return;
    setMensajeError("ERRORDB");
  }, [errorTipoAccesoByInsumo]);    

  const [getCompatibilidadesByInsumo, { error: errorCompatibilidadByInsumo, data: dataCompatibilidadByInsumo }] = useLazyQuery(GET_COMPATIBILIDADES_BY_INSUMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCompatibilidadByInsumo) return;
    if (dataCompatibilidadByInsumo.compatibilidad.success) {
      const data = dataCompatibilidadByInsumo.compatibilidad.valorEsperado;
      setListaCompatibilidad(data);
    };
  }, [dataCompatibilidadByInsumo]);

  useEffect(() => {
    if (!errorCompatibilidadByInsumo) return;
    setMensajeError("ERRORDB");
  }, [errorCompatibilidadByInsumo]);    

  const [getTMByInsumo, { error: errorTMByInsumo, data: dataTMByInsumo }] = useLazyQuery(GET_TM_BY_INSUMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTMByInsumo) return;
    if (dataTMByInsumo.tecnologiaMedica.success) {
      const data = dataTMByInsumo.tecnologiaMedica.valorEsperado;
      setListaTM(data);
    };
  }, [dataTMByInsumo]);

  useEffect(() => {
    if (!errorTMByInsumo) return;
    setMensajeError("ERRORDB");
  }, [errorTMByInsumo]);    

  const [getInsumoCajasByInsumo, { error: errorInsumoCajas, data: dataInsumoCajas }] = useLazyQuery(GET_INSUMO_CAJAS_BY_INSUMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataInsumoCajas) return;
    if (dataInsumoCajas.insumoCajas.success) {
      setListaProductosCaja(dataInsumoCajas.insumoCajas.valorEsperado);
    };
  }, [dataInsumoCajas]);

  useEffect(() => {
    if (!errorInsumoCajas) return;
    setMensajeError("ERRORDB");
  }, [errorInsumoCajas]);    

  const [getProgramasByInsumo, { error: errorProgramas, data: dataProgramas }] = useLazyQuery(GET_TIPO_MODULO_BY_INSUMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProgramas) return;
    if (dataProgramas.insumoTipoModulo.success) {
      setListaProgramas(dataProgramas.insumoTipoModulo.valorEsperado?.map((x) => {
        let item = {
          idInsumo: x.idInsumo,
          idTipoModulo: x.idModuloTipo
        };
        return item;
      }));
    };
  }, [dataProgramas]);

  useEffect(() => {
    if (!errorProgramas) return;
    setMensajeError("ERRORDB");
  }, [errorProgramas]);    

  const [saveProducto, { dataMGuardarInsumo }] = useMutation(POST_SAVE_INSUMO, {
    onCompleted: (dataMGuardarInsumo) => {
      if (dataMGuardarInsumo.saveProducto.success) {
        toast.success("Se grabó el producto correctamente");
        navigate('/insumoAdmin/');
      } else {
        if (dataMGuardarInsumo.saveProducto.error === 'ERRORDB' || parseInt(dataMGuardarInsumo.saveProducto.error, 10) > 0) {
          setMensajeError(dataMGuardarInsumo.saveProducto.error);
        } else
        {
          toast.error(dataMGuardarInsumo.saveProducto.error);
        }
      }
    },
    onError: (dataMGuardarInsumo) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  // funciones
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}>
        
                {value === index &&
        <Box>
                        <Typography>{children}</Typography>
                    </Box>
        }
            </div>);

  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };


  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }

  // handles
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickGrabar = async () => {
    setGrabarLoading(true);
    if (isFormValid()) {
      await GuardarInsumo();
    }
    setGrabarLoading(false);
  };

  const isFormValid = () => {
    const datosGenerales = insumoData.datosGenerales;
    const datosCategorizacion = insumoData.datosCategorizacion;

    if (datosGenerales.IdInsumo.length <= 0) {
      toast.error('Debe ingresar el id de Insumo.');
      return false;
    }
    if (datosGenerales.IdFabricante <= 0) {
      toast.error('Debe ingresar el fabricante.');
      return false;
    }
    if (datosGenerales.IdTipoInsumo <= 0) {
      toast.error('Debe ingresar el tipo de insumo.');
      return false;
    } else
    {
      // caja
      if (datosGenerales.IdTipoInsumo == 2) {
        if (datosGenerales.CantidadDias <= 0) {
          toast.error('La cantidad de días deben ser mayor a cero.');
          return false;
        }
      }
      // NUTRICIÓN
      if (datosGenerales.IdTipoInsumo == 1) {
        if (datosGenerales.Calorias < 0) {
          toast.error('Las calorías deben ser mayor o igual a cero.');
          return false;
        }
        if (datosGenerales.Proteinas < 0) {
          toast.error('Las proteínas deben ser mayor o igual a cero.');
          return false;
        }
      }
    }
    if (datosGenerales.Descripcion.length <= 0) {
      toast.error('Debe ingresar la descripción.');
      return false;
    }
    if (datosGenerales.PresentacionComercial.length <= 0) {
      toast.error('Debe ingresar la presentacion comercial.');
      return false;
    }
    if (datosGenerales.CantidadPack.length <= 0) {
      toast.error('Debe ingresar la cantidad por caja.');
      return false;
    }
    if (datosGenerales.Peso.length <= 0) {
      toast.error('Debe ingresar el peso.');
      return false;
    }

    return true;
  };

  const GuardarInsumo = async () => {
    let idUsuario = parseInt(sessionStorage.getItem('idUsuario'));
    let productoCategoria = insumoData.datosCategorizacion;

    let categorizacion = {
      idInsumo: id,
      eleccion: productoCategoria.IdEleccion ? productoCategoria.IdEleccion : 0
    };


    let alergias = listaAlergias.map((item) => {
      let obj = {
        idInsumo: id,
        idAlergia: item.idAlergia
      };

      return obj;
    });

    let compatibilidades = listaCompatibilidad.map((item) => {
      let obj = {
        idInsumo: id,
        idInsumoCompatible: item.idCompatibilidad
      };

      return obj;
    });

    let tecnologiasMedicas = listaTM.map((item) => {
      let obj = {
        idInsumo: id,
        idInsumoTM: item.idInsumoTM
      };

      return obj;
    });

    let tiposAcceso = listaAccesos.map((item) => {
      let obj = {
        idTipoAcceso: item.idTipoAcceso,
        idInsumo: id
      };

      return obj;
    });

    let insumosCaja = listaProductosCaja.map((item) => {
      let obj = {
        idInsumoCaja: item.idInsumoCaja,
        idInsumo: id,
        cantidad: item.cantidad
      };

      return obj;
    });

    let costos = listaDatosContables.map((item) => {
      let obj = {
        idCostoInsumo: item.idCostoInsumo,
        idInsumo: id,
        idDelegacion: item.idDelegacion,
        mes: item.mes,
        anio: item.anio,
        iva: item.iva,
        costo1: item.costo1,
        costo2: item.costo2,
        costoInterno: item.costoInterno,
        cod_Proveedor: item.cod_Proveedor,
        delegacion: '',
        proveedor: item.proveedor
      };

      return obj;
    });

    let dataGeneral = insumoData.datosGenerales;

    let producto = {
      idInsumoN: id,
      idInsumo: dataGeneral.IdInsumo,
      descripcion: dataGeneral.Descripcion,
      codigoBarra: '',
      presentacion: parseFloat(dataGeneral.PresentacionComercial),
      idUnidad: dataGeneral.IdUnidad + 1,
      idFabricante: dataGeneral.IdFabricante,
      idTipoInsumo: dataGeneral.IdTipoInsumo,
      activo: dataGeneral.Activo,
      fechaAlta: getDateNow(),
      idUsuario: idUsuario,
      fechaModificacion: getDateNow(),
      idUsuarioModificacion: idUsuario,
      descripcionGenerica: dataGeneral.DescripcionGenerica,
      presentacionGenerica: dataGeneral.PresentacionGenerica,
      idFranjaEtarea: dataGeneral.IdFranjaEtarea + 1,
      cantXPack: parseInt(dataGeneral.CantidadPack),
      pesoUnitario: parseFloat(dataGeneral.Peso),
      esSap: dataGeneral.EsSAP > 0,
      cantXDia: parseInt(dataGeneral.CantidadDias),
      tipoInsumo: '',
      eleccion: productoCategoria.IdEleccion ? productoCategoria.IdEleccion : 0,
      validado: dataGeneral.Validado,
      motivoValidacion: dataGeneral.MotivoValidacion,
      unidadVenta: parseInt(dataGeneral.UnidadVenta),
      fraccionable: dataGeneral.Fraccionable,
      calorias: dataGeneral.Calorias ? parseFloat(dataGeneral.Calorias) : 0,
      proteinas: dataGeneral.Proteinas ? parseFloat(dataGeneral.Proteinas) : 0
    };

    let programas = listaProgramas.map((item) => {
      let obj = {
        idInsumo: id,
        idTipoModulo: item.idTipoModulo,
        idUsuario: 0
      };

      return obj;
    });

    await saveProducto({
      variables: {
        producto: producto,
        listaAlergias: alergias,
        listaCompatibilidades: compatibilidades,
        listaTecnologiasMedicas: tecnologiasMedicas,
        listaTipoAccesos: tiposAcceso,
        listaInsumosCaja: insumosCaja,
        listaCostos: costos,
        listaProgramas: programas
      }
    });
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const clickCancel = () => {
    navigate('/insumoAdmin/');
  };

  return (
    <>
            <div className='insumo-principal'>
                <TabPanel value={value} index={0}>
                    <TabDatosGenerales
            insumo={insumoData.datosGenerales}
            setInsumo={setInsumoData}
            unidades={unidades}
            fabricantes={fabricantes}
            tipoInsumos={tipoInsumos}
            franjaEtarias={franjaEtarias}
            setListaTM={setListaTM}
            setListaProductosCaja={setListaProductosCaja}
            setListaAccesos={setListaAccesos}
            listaInsumos={listaInsumos}
            edit={edit} />
          
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <TabDatosContables
            listaDatosContables={listaDatosContables}
            setListaDatosContables={setListaDatosContables}
            permisoGrabar={showGrabar} />
          
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <TabContraindicaciones
            idInsumo={insumoData.datosGenerales.IdInsumo}
            alergias={alergias}
            listaAlergias={listaAlergias}
            setListaAlergias={setListaAlergias}
            listaCompatibilidad={listaCompatibilidad}
            setListaCompatibilidad={setListaCompatibilidad} />
          
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <TabProgramas
            idInsumo={insumoData.datosGenerales.IdInsumo}
            listaProgramas={listaProgramas}
            setListaProgramas={setListaProgramas} />
          
                </TabPanel>
                {(insumoData.datosGenerales.IdTipoInsumo == 1 || insumoData.datosGenerales.IdTipoInsumo == 2) &&
        <TabPanel value={value} index={4}>
                        <TabCategorizacion
            insumo={insumoData.datosCategorizacion}
            setInsumo={setInsumoData}
            idTipoInsumo={insumoData.datosGenerales.IdTipoInsumo}
            tiposAcceso={tiposAcceso}
            listaTM={listaTM}
            setListaTM={setListaTM}
            listaProductosCaja={listaProductosCaja}
            setListaProductosCaja={setListaProductosCaja}
            listaAccesos={listaAccesos}
            setListaAccesos={setListaAccesos} />
          
                    </TabPanel>
        }
            </div>

            <ErrorDialog
        id="dlg-error-chgpass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      

        </>);

}